import { render, staticRenderFns } from "./fadescaleout.vue?vue&type=template&id=5b2cc7a1&scoped=true&"
import script from "./fadescaleout.vue?vue&type=script&lang=js&"
export * from "./fadescaleout.vue?vue&type=script&lang=js&"
import style0 from "./fadescaleout.vue?vue&type=style&index=0&id=5b2cc7a1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2cc7a1",
  null
  
)

export default component.exports